(function ($) {
	class W4D_Login {
		constructor() {
			this.button = document.querySelector('[data-login-trigger]');
			this.dialog = document.querySelector('.login-dialog');
			this.popover = document.querySelector('.login-popover');
			this.template = document.querySelector('[data-login-content]');

			const hasResponsive = this.button && this.dialog && this.popover && this.template;

			if (hasResponsive) {
				this.content = this.template.content.querySelector('.login');

				if (this.content) {
					this.mq = window.matchMedia('(min-width: 768px)');

					// apply() must run BEFORE initSelectors() so the form is
					// in the live DOM when jQuery validate binds to it. Without
					// this order the form lives inside a <template> DocumentFragment
					// which is invisible to querySelectorAll / jQuery, causing
					// validate() to never attach and the form to fall back to a
					// native GET submission that leaks credentials into the URL.
					this.apply(this.mq.matches);

					this.mq.addEventListener('change', (e) => this.apply(e.matches));

					// Safari polyfill for closedby="any" light-dismiss
					this.dialog.addEventListener('click', (event) => {
						if ('closedBy' in HTMLDialogElement.prototype) return;
						if (this.dialog.getAttribute('closedby') !== 'any') return;
						if (event.target === this.dialog) this.dialog.close();
					});
				}
			}

			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.$form = $('[data-js="login-form"]');
			this.$submitBtn = this.$form.find('[data-js="login-submit"]');
			this.loader = this.$submitBtn.find('.loader-1');
		}

		bindEvents() {
			this.$form.validate({
				submitHandler: (form) => this.handleSubmit(form),
			});

			$(document).on('click', '.w4d-logout', (e) => this.handleLogout(e));

			// Delegated close-button handler for <dialog> elements
			document.addEventListener('click', (event) => {
				const closeButton = event.target.closest('.close');
				if (!closeButton) return;
				const dialog = closeButton.closest('dialog');
				if (dialog) dialog.close();
			});
		}

		apply(isDesktop) {
			this.isDesktop = isDesktop;

			if (isDesktop) {
				if (this.dialog.open) this.dialog.close();
				this.popover.appendChild(this.content);
				this.button.setAttribute('command', 'toggle-popover');
				this.button.setAttribute('commandfor', 'login-popover');
			} else {
				if (this.popover.matches(':popover-open')) this.popover.hidePopover();
				this.dialog.appendChild(this.content);
				this.button.setAttribute('command', 'show-modal');
				this.button.setAttribute('commandfor', 'login-dialog');
			}
		}

		setButtonLoading($button, isLoading) {
			if (isLoading) {
				$button.toggleClass('btn--loading', true);
				$button.prop('disabled', true);
			} else {
				setTimeout(() => {
					$button.toggleClass('btn--loading', false);
					$button.prop('disabled', false);
				}, 2500);
			}
		}

		handleSubmit(form) {
			const fd = new FormData(form);
			fd.append('action', 'w4d_user_login');
			fd.append('nonce', w4d_frontend_ajax.nonce);

			$.ajax({
				url: w4d_frontend_ajax.ajax_url,
				type: 'POST',
				data: fd,
				processData: false,
				contentType: false,
				beforeSend: () => this.setButtonLoading(this.$submitBtn, true),
				success: (response) => {
					if (response.success) {
						if (response.data.redirect) {
							window.location.href = response.data.redirect;
						} else {
							window.location.reload();
						}
					} else {
						W4D_Toast.showToast('error', response.data.message);
					}
				},
				error: (xhr, status, error) => {
					console.error('Login error:', error);
					W4D_Toast.showToast('error', 'Došlo je do greške prilikom prijave. Molimo pokušajte ponovno.');
				},
				complete: () => this.setButtonLoading(this.$submitBtn, false),
			});
		}

		handleLogout(e) {
			if (e) e.preventDefault();

			const $button = $(e.currentTarget);

			$.ajax({
				url: w4d_frontend_ajax.ajax_url,
				type: 'POST',
				data: {
					action: 'w4d_user_logout',
					nonce: w4d_frontend_ajax.nonce,
				},
				beforeSend: () => this.setButtonLoading($button, true),
				success: (response) => {
					if (response.success) {
						if (response.data?.redirect) {
							window.location.href = response.data.redirect;
						} else {
							window.location.reload();
						}
					} else {
						W4D_Toast.showToast('error', response.data?.message || 'Greška prilikom odjave.');
					}
				},
				error: (xhr, status, error) => {
					console.error('Logout error:', error);
					W4D_Toast.showToast('error', 'Došlo je do greške prilikom odjave. Molimo pokušajte ponovno.');
				},
				complete: () => this.setButtonLoading($button, false),
			});
		}
	}

	$(document).ready(() => {
		new W4D_Login();
	});
})(jQuery);
